import * as tslib_1 from "tslib";
import { NodeBase } from "./NodeBase";
import { PartitionBase } from "./PartitionBase";
/**
 * @class away.partition.Partition
 */
var BasicPartition = (function (_super) {
    tslib_1.__extends(BasicPartition, _super);
    function BasicPartition(root) {
        var _this = _super.call(this, root) || this;
        _this._rootNode = new NodeBase();
        return _this;
    }
    return BasicPartition;
}(PartitionBase));
export { BasicPartition };



// WEBPACK FOOTER //
// ../dist/lib/partition/BasicPartition.js